import React from 'react';
import Main from '../../organisms/Main/Main';

function Search() {
	return (
		<>
			<Main title='Wyszukaj frazy...' category='search' />
			<br />
			<br />
			<br />
		</>
	);
}

export default Search;
